import script from "./FinanceManager.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceManager.vue?vue&type=script&setup=true&lang=js"

import "./FinanceManager.vue?vue&type=style&index=0&id=67a546a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67a546a8"]])

export default __exports__